<template>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
        <div
            class="w-full"
            v-for="stat in stats"
            :key="stat.slug"
        >
            <div class="w-full">
                <div class="flex flex-row">
                    <div class="flex items-end font-medium text-gray-900 ds-text-4xl md:flex-row">
                        <div class="text-4xl whitespace-no-wrap inbetween-fix">{{ formatValue(stat.value, stat.unit) }}</div>
                        <div class="ds-text-2xl" style="margin-bottom: 1px;">{{ isViewable(stat.unit, stat.value) }}</div>
                        <component 
                        :is="stat.unit_icon_component"
                        class="w-auto mb-2"
                        :class="[stat.unit_image_height, stat.unit === 'inches' ? '-ml-2' : 'ml-1']"
                        v-if="stat.unit_icon_component"
                        />
                    </div>
                </div>
                <p class="m-0 font-semibold text-gray-500 uppercase ds-text-xs">{{stat.label}}</p>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        stats: {
            type: Array
        }
    },
    data() {
        return {
            statAbbreviations: {
                mph: 'mph',
                seconds: 's',
            } 
        }
    },
    methods:{
        isViewable(unit, value) {
            if (Object.keys(this.statAbbreviations).includes(unit)) {
                return this.statAbbreviations[unit];
            } 

            // disabled at andy's request to just show the time formatted as HH:MM:SS.hs
            // else if (unit === 'seconds' && !this.hasMinutes(value)) {
            //     return this.statAbbreviations[unit];
            // }
        },
        hasMinutes(stat) {
        return (stat / 60) >= 1;
        },
        formatValue(stat, unit) {
            // Format seconds into a full time, can also be used for the other stats depending on how they come in.
            if (unit === 'seconds') {
                let hours = Math.floor(stat/ 3600);
                let remainingSeconds = stat % 3600;
                let minutes = Math.floor(remainingSeconds / 60);
                let fullSeconds = remainingSeconds % 59.999; // weird float math? 
                let splitSeconds = fullSeconds.toString().split('.');
                let seconds = splitSeconds[0];
                let hs = splitSeconds[1];
                hours = hours ? hours.toString().padStart(2,'0') + ':' : '';
                minutes = minutes ? minutes.toString().padStart(2,'0') + ':' : '';
                seconds = seconds ? (minutes ? seconds.toString().padStart(2,'0') : seconds) + (hs ? '.' : '') : '';
                hs = hs ? hs.substr(0,2) : '';

                return `${hours+minutes+seconds+hs}`;
            } else if (unit === 'inches') {
                return `${Math.floor(stat / 12)}'${Math.ceil(stat % 12)}"`
            } else {
                return stat;
            }
        }
    }
}
</script>
<style lang="scss">
    .cls-1 {
        fill: black !important;
    }
    .inbetween-fix {
        @media screen and (min-width: 768px) and (max-width: 814px) {
            font-size: 29px !important;
        }
    }
</style>
